import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled';

import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import type { ApplicationLinkV3Data } from '../common/types.tsx';
import ApplinksTable from './applinks-table/index.tsx';
import ApplinksHeader from './applinks-header/index.tsx';

const ApplinksPageContents = (props: { applinks: ApplicationLinkV3Data[] | null }) => {
	return (
		<>
			<JSErrorBoundary
				id="applinks-administration-healthcheck-page"
				teamName="olympus"
				packageName="applinksExtraAuthHealthcheckPage"
			>
				<Stack space="space.200">
					<ApplinksHeader />
					<Stack space="space.800">
						<ApplinksTable applinks={props.applinks} />
					</Stack>
				</Stack>
			</JSErrorBoundary>
		</>
	);
};

export default ApplinksPageContents;
